






































import {Component, Vue, Emit} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import * as types from '@/mutation-types';
import util from '@/utilities/index';
import { UserMenuItems } from '@/menu';
import { Getter } from 'vuex-class';
import Api from '../Api';
const namespace: string = 'AppStore';

@Component({
  components: {
    SearchBar,
  },
})
export default class AppHeader extends Vue {
  @Getter('initial', { namespace }) public initial!: string;
  public items: any = UserMenuItems;
  public proPics: any = [];
    public handleDrawerHandle() {
      window.eventBus.$emit(types.APP_DRAWER_TOGGLED);
    }

    public handleFullScreen() {
      util.toggleFullScreen();
    }
    public load() {
      Api.Instance
      .get('/api/profile-image')
      .then((response) => {
        this.proPics = response.data;
      });
    }
    public mounted() {
      this.load();
    }
}
